import { ActionTypes } from 'redux/utils/Data'

export default ActionTypes('ASSESSMENT_DEFAULT')